import axiosInstance from './axiosInstance';

export const fetchEnergyData = async (searchParams) => {
  try {
    const response = await axiosInstance.post('energydata/search', searchParams, {
      params: {
        page: searchParams.page,
        size: searchParams.size
      }
    });
    return response.data; // Assuming pagination structure with content array
  } catch (error) {
    console.error('Error fetching energy data:', error);
    throw error;
  }
};

export const fetchEnergyDataById = async (id) => {
    try {
        const response = await axiosInstance.get(`energydata/${id}`);
        return response.data;
      } catch (error) {
        console.error('Error fetching energy data:', error);
        throw error;
      }
}

export const saveEnergyData = async (energyData) => {
    try{
        const response = await axiosInstance.put('energystats',energyData);
        return response.data;
    } catch (error) {
        console.error('Error saving energy data:', error);
        throw error;
    }
}

export const deleteEnergyData = async (id) => {
    try{
        const response = await axiosInstance.delete(`energystats/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error saving energy data:', error);
        throw error;
    }
}

// Upload Excel file
export const uploadEnergyData = async (file, templateId) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("templateId", templateId);

  try {
      const response = await axiosInstance.post('energystats/upload-data', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
  } catch (error) {
      console.error('Error uploading energy data:', error);
      throw error;
  }
};

export const downloadEnergyTemplate = async (searchParams) => {
  try {
      const response = await axiosInstance.post('energystats/download', searchParams, {
          responseType: 'blob' // Important for downloading files
      });

      // Extract filename from Content-Disposition header
      const contentDisposition = response.headers['content-disposition'];
      let filename = 'EnergyDataTemplate.xlsx'; // Default fallback filename

      if (contentDisposition) {
          const match = contentDisposition.match(/filename="(.+)"/);
          if (match && match[1]) {
              filename = match[1];
          }
      }

      // Create a download link for the user
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      return response.data;
  } catch (error) {
      console.error('Error downloading energy template:', error);
      throw error;
  }
};

export const synchronizeAllData = async () => {
  try {
    const response = await axiosInstance.get('energyreport/export-all', {
      responseType: 'blob'
    });

    const contentDisposition = response.headers['content-disposition'];
    let filename = 'statistics.json';

    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?([^"]+)"?/);
      if (match && match[1]) {
        filename = match[1];
      }
    }

    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/json' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return response.data; 
  } catch (error) {
    console.error('Error synchronizing energy data:', error);
    throw error;
  }
};
